module.exports = __webpack_public_path__ + "static/media/Sanmartino.5748c7e8.png";